import { useCallback, useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { notification } from 'antd'
import { useTranslation } from 'react-i18next'
import { useApiMutation } from '@BUP/hooks/useApiMutation'

export const useUpdateRegistration = userName => {
  const i18n = useTranslation()
  const queryClient = useQueryClient()
  const [updateError, setUpdateError] = useState(null)

  const mutation = useApiMutation(
    'schools',
    ({ registrationId }) => `/registrations/${registrationId}`,
    'patch',
    {
      onSuccess: () => {
        queryClient.removeQueries({ queryKey: ['enrollments-by-role-type'], type: 'inactive' })
        queryClient.removeQueries({ queryKey: ['registrations'], type: 'inactive' })
        queryClient.removeQueries({ queryKey: ['courses-by-term'], type: 'inactive' })
        queryClient.invalidateQueries({ queryKey: ['enrollments-by-role-type'] })
        queryClient.invalidateQueries({ queryKey: ['registrations'] })
        queryClient.invalidateQueries({ queryKey: ['courses-by-term'] })
        notification.info({
          style: { fontWeight: 500, fontSize: 17 },
          duration: 5,
          message: i18n.t('pages.MySchool.alertText.userEditedSuccessfully', { userName })
        })
      },
      onError: error => {
        setUpdateError(error.response)
        const errorType = error.response?.data?.type
        let message
        switch (errorType) {
          case 'registration/update/already-exists':
            message = i18n.t('pages.MySchool.alertText.userAlreadyExistsInCourse', { userName })
            break
          default:
            message = i18n.t('pages.MySchool.alertText.errorEditingUser', { userName })
        }
        notification.error({
          style: { fontWeight: 500, fontSize: 17 },
          duration: 5,
          message
        })
      }
    },
    { authenticated: true, version: 4 }
  )
  const { mutateAsync } = mutation

  const updateRegistration = useCallback(async (registrationId, courseId) => {
    return mutateAsync({
      registrationId,
      data: {
        courseId
      }
    })
      .catch(error => {
        console.error(error)
        return null
      })
  }, [mutateAsync])

  return {
    updateRegistration,
    updateError,
    updateLoading: mutation.isPending
  }
}
